export const LOADING = "LOADING";
export const SIGNIN_RESPONSE = "SIGNIN_RESPONSE";
export const SIGNUP_RESPONSE = "SIGNUP_RESPONSE";
export const FORGOT_RESPONSE = "FORGOT_RESPONSE";
export const REFRESH_RESPONSE = "REFRESH_RESPONSE";
export const RESET_RESPONSE = "RESET_RESPONSE";
export const RESEND_RESPONSE = "RESEND_RESPONSE";
